import React from 'react';
import { Button } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const RemainingItems = styled.span`
  margin-left: 10px;
  color: #999;
`;

const StyledButton = styled(Button)`
  span {
    margin-right: 5px;
  }
`;

const PagingFooter = ({ pageSize, remaining, showMore }) =>
  remaining > 0 ?
    <div>
      <StyledButton icon={<EyeOutlined />} onClick={showMore}>
        <FormattedMessage
          id='table.SHOW_MORE_COUNT'
          values={{ count: pageSize < remaining ? pageSize : remaining }}
        />
      </StyledButton>
      <RemainingItems>
        (<FormattedMessage
          id='table.REMAINING_COUNT'
          values={{ count: remaining }}
        />)
      </RemainingItems>
    </div> :
    null;

PagingFooter.propTypes = {
  pageSize: PropTypes.number,
  remaining: PropTypes.number,
  showMore: PropTypes.func,
};

export default PagingFooter;
